module.exports = __webpack_public_path__ + "static/img/no-notice.b532c05.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layout/pages/home/home-notice/images/no-notice.svg
// module id = zgys
// module chunks = 7